export const IDENTITY_APP_URL =
  process.env.REACT_APP_IDENTITY_APP_URL || 'http://localhost:3002';
export const FINANCE_APP_URL =
  process.env.REACT_APP_FINANCE_APP_URL || 'http://localhost:3001';
export const GATEKEEPER_APP_URL =
  process.env.REACT_GATEKEEPER_APP_URL || 'http://localhost:3002';
export const TRANSACTIONS_APP_URL =
  process.env.REACT_APP_TRANSACTIONS_APP_URL || 'http://localhost:3004';
export const KYC_APP_URL =
  process.env.REACT_APP_KYC_APP_URL || 'http://localhost:3005';
export const USERS_APP_URL =
  process.env.REACT_APP_USERS_APP_URL || 'http://localhost:3006';
export const ADMINISTRATION_APP_URL =
  process.env.REACT_APP_ADMINISTRATION_APP_URL || 'http://localhost:3007';

export const REMOTE_URLS = {
  identity: IDENTITY_APP_URL,
  gatekeeper: GATEKEEPER_APP_URL,
  finance: FINANCE_APP_URL,
  transactions: TRANSACTIONS_APP_URL,
  kyc: KYC_APP_URL,
  users: USERS_APP_URL,
  administration: ADMINISTRATION_APP_URL,
};
